import { UnitTransferSignatureStatusEnumType } from '__generated__/graphql';

export default function unitTransferSignatureStatusToReadable(
  status: UnitTransferSignatureStatusEnumType
): {
  label: string;
  color: string;
} {
  switch (status) {
    case UnitTransferSignatureStatusEnumType.NotSent:
      return { label: 'Not Sent', color: 'gray' };
    case UnitTransferSignatureStatusEnumType.Sent:
      return { label: 'Sent', color: 'sky' };
    case UnitTransferSignatureStatusEnumType.PartiallySigned:
      return { label: 'Partially Signed', color: 'amber' };
    case UnitTransferSignatureStatusEnumType.Signed:
      return { label: 'Signed', color: 'green' };
    case UnitTransferSignatureStatusEnumType.Declined:
      return { label: 'Declined', color: 'red' };
    case UnitTransferSignatureStatusEnumType.Expired:
      return { label: 'Expired', color: 'red' };
    case UnitTransferSignatureStatusEnumType.Error:
      return { label: 'Error', color: 'red' };
    default:
      return { label: status, color: 'gray' };
  }
}
